import { Break, Paragraph, Title } from '../Common';

function FourOhFour(): JSX.Element {
  return (
    <>
      <Title>404</Title>
      <Break />
      <Paragraph>Nothing could be found at this address.</Paragraph>
    </>
  );
}

export default FourOhFour;
